import { render, staticRenderFns } from "./SampleLogin.vue?vue&type=template&id=97b4c144"
import script from "./SampleLogin.vue?vue&type=script&lang=js"
export * from "./SampleLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97b4c144')) {
      api.createRecord('97b4c144', component.options)
    } else {
      api.reload('97b4c144', component.options)
    }
    module.hot.accept("./SampleLogin.vue?vue&type=template&id=97b4c144", function () {
      api.rerender('97b4c144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleLogin.vue"
export default component.exports